import React from "react"
import { Card, Grid, Icon } from "semantic-ui-react"
import { NavLink } from "react-router-dom"
import { formatCurrency } from "uikit"

const GroupLifePlanCard = ({
  id,
  name,
  type,
  label,
  ownerName,
  employerName,
  spouseName,
  death_benefit,
  death_benefit_spouse
}) => {
  const benefitLabel =
    spouseName && death_benefit_spouse > 0
      ? "Joint Death Benefit"
      : "Death Benefit"
  const benefitAmount =
    spouseName && death_benefit_spouse > 0
      ? death_benefit + death_benefit_spouse
      : death_benefit
  const peopleName =
    spouseName && death_benefit_spouse > 0
      ? ownerName + " & " + spouseName
      : ownerName
  return (
    <Card>
      <Card.Content>
        <Grid style={{ position: "relative", height: "170px" }}>
          <Grid.Row columns={2} verticalAlign="top">
            <Grid.Column>
              <NavLink
                to={`/organize/income+benefits/benefits/${id}/${type.toLowerCase()}`}
                className="navlink"
              >
                <span className="GenericCard__LinkTitle">
                  Life Insurance
                  <Icon name="chevron right" size="small" />
                </span>
                <p className="greyed-text">
                  {employerName && `Sponsored by ${employerName}`}
                </p>
              </NavLink>
            </Grid.Column>
            <Grid.Column textAlign="right">
              <p className="GenericCard__Balance">
                {formatCurrency(benefitAmount)}
              </p>
              <p className="greyed-text">{benefitLabel}</p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={2} verticalAlign="bottom">
            <Grid.Column>
              <p className="greyed-text">{peopleName}</p>
            </Grid.Column>
            <Grid.Column textAlign="right">
              <p className="greyed-text">{label}</p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card.Content>
    </Card>
  )
}

export default GroupLifePlanCard
